module.exports = __webpack_public_path__ + "img/member.7f50c1d7.svg";